// The flags one enquiry carries, as chips. Renders exactly the keys the server sent for the row
// (`flags`), never a list built in the browser; nothing when there are none.

import { Chip } from '@mui/material';
import type { EnquiryFlagKey } from '../../../api/enquiry.api';
import { ENQUIRY_FLAG_COLORS, ENQUIRY_FLAG_LABELS, isEnquiryFlagKey } from '../../../utils/enquiryFlags';

export default function EnquiryFlagChips({ flags }: { flags: EnquiryFlagKey[] | null | undefined }) {
  if (!Array.isArray(flags)) return null;
  return (
    <>
      {flags.filter(isEnquiryFlagKey).map((key) => (
        <Chip
          key={key}
          size="small"
          label={ENQUIRY_FLAG_LABELS[key]}
          data-testid={`enquiry-flag-${key}`}
          sx={{ bgcolor: ENQUIRY_FLAG_COLORS[key].bg, color: ENQUIRY_FLAG_COLORS[key].text, fontWeight: 600 }}
        />
      ))}
    </>
  );
}
